/* eslint-disable max-lines-per-function */
import GlobalTopic from "@/utilities/global-topic";

import { Constants } from "customer-sdk/constants";
const EVENTS = Constants.EVENTS;

export const renderSnackbarMessage = (message, timeout) => {
  GlobalTopic.publishChange({
    type: EVENTS.ON_OPEN_SNACKBAR,
    data: {
      snackbarText: message,
      timeout: timeout,
    },
  });
};

export const handleSnackbar = (component) => {
  GlobalTopic.addListener((msg) => {
    if (msg.type === EVENTS.ON_OPEN_SNACKBAR) {
      component.snackbarText = msg.data.snackbarText;
      component.isSnackbarActive = true;
      component.snackbarTimeout = msg.data.timeout;
      component.$toasted.show(component.snackbarText, {
        theme: "toasted-primary",
        position: "top-center",
        duration: component.snackbarTimeout ? component.snackbarTimeout : 2000,
        action: {
          text: "close",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      });
    } else if (msg.type === EVENTS.ON_OPEN_SUCCESS_SNACKBAR) {
      component.snackbarText = msg.data.snackbarText;
      component.isSnackbarActive = true;
      component.snackbarTimeout = msg.data.timeout;
      component.$toasted.show(
        `
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-right: 6px;" class="toasted-svg-icon">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M17.25 9V8.325C17.25 7.875 16.95 7.575 16.5 7.575C16.05 7.575 15.75 7.875 15.75 8.325V9C15.75 12.75 12.75 15.75 9 15.75C5.25 15.75 2.25 12.75 2.25 9C2.25 5.25 5.25 2.25 9 2.25C9.975 2.25 10.875 2.475 11.775 2.85C12.15 3 12.6 2.85 12.75 2.475C12.9 2.1 12.75 1.65 12.375 1.5C11.325 0.975 10.125 0.75 9 0.75C4.425 0.75 0.75 4.425 0.75 9C0.75 13.575 4.425 17.25 9 17.25C13.575 17.25 17.25 13.575 17.25 9ZM16.725 1.725C17.025 1.425 17.475 1.425 17.775 1.725C18.075 2.025 18.075 2.475 17.775 2.775L9.525 11.025C9.375 11.175 9.15 11.25 9 11.25C8.85 11.25 8.625 11.175 8.475 11.025L6.225 8.775C5.925 8.475 5.925 8.025 6.225 7.725C6.525 7.425 6.975 7.425 7.275 7.725L9 9.45L16.725 1.725Z" fill="black"/>
          <mask id="mask0_963_3518" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M17.25 9V8.325C17.25 7.875 16.95 7.575 16.5 7.575C16.05 7.575 15.75 7.875 15.75 8.325V9C15.75 12.75 12.75 15.75 9 15.75C5.25 15.75 2.25 12.75 2.25 9C2.25 5.25 5.25 2.25 9 2.25C9.975 2.25 10.875 2.475 11.775 2.85C12.15 3 12.6 2.85 12.75 2.475C12.9 2.1 12.75 1.65 12.375 1.5C11.325 0.975 10.125 0.75 9 0.75C4.425 0.75 0.75 4.425 0.75 9C0.75 13.575 4.425 17.25 9 17.25C13.575 17.25 17.25 13.575 17.25 9ZM16.725 1.725C17.025 1.425 17.475 1.425 17.775 1.725C18.075 2.025 18.075 2.475 17.775 2.775L9.525 11.025C9.375 11.175 9.15 11.25 9 11.25C8.85 11.25 8.625 11.175 8.475 11.025L6.225 8.775C5.925 8.475 5.925 8.025 6.225 7.725C6.525 7.425 6.975 7.425 7.275 7.725L9 9.45L16.725 1.725Z" fill="white"/>
          </mask>
          <g mask="url(#mask0_963_3518)">
            <rect width="18" height="18" fill="#1A8474"/>
          </g>
        </svg>
        ${component.snackbarText}
      `,
        {
          theme: "toasted-primary",
          position: "top-center",
          duration: component.snackbarTimeout ? component.snackbarTimeout : 2000,
          action: {
            icon: "close",
            onClick: (e, toastObject) => toastObject.goAway(0),
          },
          type: "success",
        }
      );
    }
  });
};
